import { SortableContext } from '@dnd-kit/sortable';
import React from 'react';
import { v4 as uuid } from 'uuid';

import { LinkButton } from '@eika/button';
import { IconTypes } from '@eika/icon';

import useTranslation from '../../../../../../hooks/useTranslation';
import { SortableListProps } from '../../../../../../models/account';
import { DragHandleDots, SortableItem, Dnd, useDndContext } from './components';
import { GroupHeader } from './components/GroupHeader/GroupHeader';
import { deleteGroup } from './utils';

import './GroupedSortableDnd.scss';

export function GroupedSortableDnd({ renderItem }: SortableListProps) {
    const translated = useTranslation();
    const {
        viewMode: [, setViewMode],
        editedHeader: [editedHeader, setEditedHeader],
        headerValue: [, setHeaderValue],
        grouped: [groupedItems, setGroupedItems],
    } = useDndContext();

    const addNewGroup = () => {
        setGroupedItems([
            ...groupedItems,
            { name: translated.editAccounts.newGroupName, id: uuid(), values: [], isTemp: true },
        ]);
    };

    const onEdit = (value: string) => {
        setViewMode('edit');
        setEditedHeader(value);
    };

    const onDelete = (value: string) => {
        setGroupedItems(deleteGroup(groupedItems, value));
        setViewMode('display');
    };

    const onNameChange = (name: string) => {
        setHeaderValue(name);
    };

    return (
        <Dnd renderItem={renderItem}>
            <ul className="grouped-sortable-dnd" role="application">
                {groupedItems.map((group) => (
                    <React.Fragment key={group.id}>
                        <GroupHeader
                            id={group.id}
                            name={group.name}
                            onEdit={onEdit}
                            onDelete={onDelete}
                            onChange={onNameChange}
                            mode={editedHeader === group.id ? 'edit' : 'display'}
                            removable={groupedItems.length > 1}
                        />
                        <SortableContext key={group.id} id={group.id} items={group.values}>
                            {group.values.map((item) => (
                                <React.Fragment key={item.id}>{renderItem(item)}</React.Fragment>
                            ))}
                            {group.values.length === 0 && (
                                <p className="empty-accounts-group">{translated.accountsList.emptyAccountsGroup}</p>
                            )}
                        </SortableContext>
                    </React.Fragment>
                ))}
                <div className="new-group">
                    <LinkButton onClick={addNewGroup} icon={IconTypes.PLUSS_36}>
                        {translated.editAccounts.addNewGroup}
                    </LinkButton>
                </div>
            </ul>
        </Dnd>
    );
}

GroupedSortableDnd.Item = SortableItem;
GroupedSortableDnd.DragHandleDots = DragHandleDots;
